import HttpServerConfig from "../common/HttpServerConfig"

//拼接地址前缀
export default function httpImageToPrefix(imageData) {
    return HttpServerConfig.getMediaSrc(imageData)
}